export default __webpack_public_path__ + "static/media/python.63580e54.png";